import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_ONBOARDING_SECOND_BRANCH, SET_ONBOARDING_TYPE, SET_ONBOARDING_WAY_TO_REACH } from "../../redux/actions/types";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const options = [
  {
    id: "certificates",
    title: "Through Certificates",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Frame%20427321976.png",
    description:
      "Recognised by top recruiters to prove skills & boost credibility instantly",
    selected: false,
    width: "w-[49px]",
    height: "h-[28px]",
  },
  {
    id: "course",
    title: "Through Course",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Group%2023330.png",
    description:
      "Expert-made to fill your gaps & fast-track your career growth",
    selected: false,
    width: "w-[26px]",
    height: "h-[28px]",
  },
  {
    id: "job-preparation",
    title: "Through Job Preparation Support",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Frame%20427321976%20(1).png",
    description: "Verified by experts from Flipkart & Facebook & others...",
    selected: true,

    width: "w-[49px]",
    height: "h-[28px]",
  },
  {
    id: "cv-profile",
    title: "Through CV & Profile Building Program",
    icon: "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Onboarding/Group%2023312.png",
    description:
      "Optimised for higher ATS score & boosted recruiter visibility",
    selected: false,
    width: "w-[32px]",
    height: "h-[30px]",
  },
];

const StepFour = ({setStep}) => {
  const selectedValue = useSelector((store) => store?.onBoarding?.wayToReach) || "";
  const firstName = useSelector((store) => store?.profileDetails?.first_name);
  const dispatch = useDispatch();

  const handleSetWayToReach = (wayToReach) => {
    dispatch({type: SET_ONBOARDING_WAY_TO_REACH, payload: wayToReach});
  }

  const handleStartCareerJourney = () => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FOURTH_STEP_START_CAREER_JOURNEY_BUTTON_CLICKED);
    if(selectedValue === options[0]?.title){
      dispatch({type: SET_ONBOARDING_TYPE, payload: "certificate"});
    }
    else if(selectedValue === options[1]?.title){
      dispatch({type: SET_ONBOARDING_TYPE, payload: "course"});
    }
    else if(selectedValue === options[2]?.title){
      dispatch({type: SET_ONBOARDING_TYPE, payload: "job"});
    }
    else{
      dispatch({type: SET_ONBOARDING_TYPE, payload: "cv"});
    }


     if(selectedValue === options[2]?.title || selectedValue === options[3]?.title){
      dispatch({type: SET_ONBOARDING_SECOND_BRANCH, payload: true});
     }
     else{
      dispatch({type: SET_ONBOARDING_SECOND_BRANCH, payload: false});
     }
     setStep(5);
  }

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FOURTH_STEP_LOADED);
  }, []);

  return (
    <div className="w-full relative inline-flex flex-col items-start justify-start gap-2">
      <div className="text-left text-[24px] font-semibold leading-[125%] text-white">
        Lastly, How Do You Want To{" "}
        <span className="font-bold"> Reach Your Goal </span>, {firstName}?
      </div>

      <div className="w-full mt-8 flex flex-col  gap-3">
        {options?.map((option) => (
          <label
            key={option.id}
            htmlFor={option.id}
            className={`w-full flex cursor-pointer gap-3 items-center justify-between rounded-xl px-4 py-5 transition-all ${
              selectedValue === option.title
                ? "border-[0.7px] border-solid border-[#7fc241] bg-[#406aff33] shadow-[0px_0px_20px_#000000b2]"
                : "bg-[#406aff1a]"
            }`}
            onClick={() => handleSetWayToReach(option.title)}
          >
            <div className="inline-flex flex-1 flex-col items-start justify-center gap-3">
              <div className="text-base font-semibold leading-[20.8px] tracking-[0] text-[#70aeff] [font-family:'Inter',Helvetica]">
                {option.title}
              </div>

              <div className="inline-flex items-center gap-2">
                {option.icon && (
                  <img
                    className={`flex-shrink-0 ${option.width} ${option.height}`}
                    alt={option.title}
                    src={option.icon}
                  />
                )}

                <div className="max-w-full text-xs font-normal leading-[normal] tracking-[0] [font-family:'Inter',Helvetica]">
                  <span className="italic text-[#ffffff80]">
                    {option.description}
                  </span>
                </div>
              </div>
            </div>

            <div className="relative">
              <div
                className={`h-4 w-4 cursor-pointer rounded-full flex justify-center items-center border-2 transition-all ${
                  selectedValue === option.title
                    ? "border-[#7fc241] p-[3px]"
                    : "border-[#7fc241] bg-transparent"
                }`}
                onClick={() => handleSetWayToReach(option.title)}
              >
                {selectedValue === option.title && (
                  <div className="h-full w-full rounded-full bg-[#7fc241]"></div>
                )}
              </div>
            </div>
          </label>
        ))}
      </div>

      <button className=" mb-4 mt-8 h-12 w-full rounded-lg  bg-[#7FC241] text-center text-[16px] font-semibold text-[18px] text-[#121212] disabled:opacity-50" disabled={!selectedValue} onClick={handleStartCareerJourney}>
      Start My Career Journey Now!
        </button>
    </div>
  );
};

export default StepFour;
